<template>
  <div class="content">
    <div class="modalBox">
      <div class="modalTop" :style="{ borderColor: '#333333' }">
        <div class="topHeader">
          <Avatar
            style="background-color: #459846"
            size="large"
            icon="ios-person"
          />
        </div>
        <span class="tit">{{
          lang == "zh"
            ? immediateSupervisor.userName
            : immediateSupervisor.userEName
        }}</span>
        <!-- <div class="row">
                    <div class="tit">T1</div> 
                    <div class="userList">
                        <div style="display: flex"><Tag v-for="(chil,i1) in immediateSupervisor.t1SuccessorInfoList" :key="i1" v-if="i1<3">{{chil.userName}}</Tag></div>
                        <Poptip placement="right" width="280" v-if="immediateSupervisor.t1SuccessorInfoList.length>3">
                            <Button icon="ios-more" size="small"></Button>
                            <div class="Poptipapi" slot="content">
                                <Tag v-for="(chil,i1) in immediateSupervisor.t1SuccessorInfoList" :key="i1">{{chil.userName}}</Tag>
                            </div>
                        </Poptip>
                        <Button type="primary" v-if="immediateSupervisor.beTopLevel" style="margin-left:5px"  @click="selectUser(immediateSupervisor,1,'t1SuccessorInfoList')" icon="md-person-add" size="small"></Button>
                    </div>
                </div> -->
        <!-- <div class="row">
                    <div class="tit">T2</div> 
                    <div class="userList">
                        <div style="display: flex"><Tag v-for="(chil,i1) in immediateSupervisor.t2SuccessorInfoList" :key="i1" v-if="i1<3">{{chil.userName}}</Tag></div>
                        <Poptip placement="right" width="280" v-if="immediateSupervisor.t2SuccessorInfoList.length>3">
                            <Button icon="ios-more" size="small"></Button>
                            <div class="Poptipapi" slot="content">
                                <Tag v-for="(chil,i1) in immediateSupervisor.t2SuccessorInfoList" :key="i1">{{chil.userName}}</Tag>
                            </div>
                        </Poptip>
                        <Button type="primary" v-if="immediateSupervisor.beTopLevel" style="margin-left:5px"  @click="selectUser(immediateSupervisor,2,'t2SuccessorInfoList')" icon="md-person-add" size="small"></Button>
                    </div>
                </div> -->
      </div>
      <div class="modalContent">
        <div class="modalItem" v-for="(item, index) in dataList" :key="index">
          <Card class="cardItem" :style="{ borderColor: item.colorFlag }">
            <p slot="title" v-if="item.beNullJob == '0'">
              {{ lang == "zh" ? item.userName : item.userEName }}
              <span 
              v-if="(item.exit_impact) === 'red'"
              style="
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                margin-left: 8px;
                vertical-align: middle;
                background-color: #ff4d4f;
                box-shadow: 0 0 5px rgba(255, 77, 79, 0.5);
              "
            ></span>
            <!-- 黄色灯 -->
            <span 
              v-if="(item.exit_impact) === 'yellow'"
              style="
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                margin-left: 8px;
                vertical-align: middle;
                background-color: #faad14;
                box-shadow: 0 0 5px rgba(250, 173, 20, 0.5);
              "
            ></span>
            <!-- 绿色灯 -->
            <span 
              v-if="(item.exit_impact) === 'green'"
              style="
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                margin-left: 8px;
                vertical-align: middle;
                background-color: #52c41a;
                box-shadow: 0 0 5px rgba(82, 196, 26, 0.5);
              "
            ></span>
            <span>{{lang == "zh" ? item.talentCategoryName : item.talentCategoryEName }}</span>
            </p>
            <p slot="title" :title="item.jobName" v-else>{{ item.jobName }}</p>
            <p slot="title" >  {{lang == "zh" ? item.talent_transfer_plan_cname : item.talent_transfer_plan_ename }}</p>
          
            <a
              slot="extra"
              @click.prevent="deleteItem(item)"
              v-if="item.beNullJob == '1'"
              :disabled="
                item.stageEmpEnd == '1' ||
                  beEnd == 1 ||
                  beEnd == 4 ||
                  $route.query.tab2 == '1'
              "
            >
              <!-- <Button type="error" icon="md-trash" size="small" ></Button> -->
              <Icon type="ios-trash-outline" size="18" style="color:red"></Icon>
            </a>
            <div>
              {{ lang == "zh" ? item.positionCTitle : item.positionETitle }}
              &nbsp;
              <Icon
              type="ios-key-outline"
              size="30"
              v-if="item.key_position == '1'"
            />
            </div>
            <div class="row">
              <div class="tit">T1</div>
              <div class="userList">
                <div style="display: flex">
                  <Tag
                    v-for="(chil, i1) in item.t1SuccessorInfoList"
                    :key="i1"
                    v-if="i1 < 3"
                    >{{ lang == "zh" ? chil.userName : chil.userEName }}</Tag
                  >
                </div>
                <Poptip
                  placement="right"
                  width="280"
                  v-if="
                    item.t1SuccessorInfoList &&
                      item.t1SuccessorInfoList.length > 3
                  "
                >
                  <Button icon="ios-more" size="small"></Button>
                  <div class="Poptipapi" slot="content">
                    <Tag
                      v-for="(chil, i1) in item.t1SuccessorInfoList"
                      :key="i1"
                      >{{ lang == "zh" ? chil.userName : chil.userEName }}</Tag
                    >
                  </div>
                </Poptip>
                <div>
                  <Button
                    type="primary"
                    :disabled="
                      item.disabledFlag == 1 ||
                        beEnd == 1 ||
                        beEnd == 4 ||
                        item.stageEmpEnd == '1' ||
                        $route.query.tab2 == '1'
                    "
                    style="margin-left:5px"
                    @click="selectUser(item, 1, 't1SuccessorInfoList')"
                    icon="md-person-add"
                    size="small"
                  ></Button>
                  <Button
                    type="warning"
                    :disabled="
                      item.disabledFlag == 1 ||
                        beEnd == 1 ||
                        beEnd == 4 ||
                        item.stageEmpEnd == '1' ||
                        $route.query.tab2 == '1'
                    "
                    style="margin-left:5px"
                    @click="deleteUser(item, item.t1SuccessorInfoList, 1)"
                    icon="ios-trash-outline"
                    size="small"
                  ></Button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="tit">T2</div>
              <div class="userList">
                <div style="display: flex">
                  <Tag
                    v-for="(chil, i1) in item.t2SuccessorInfoList"
                    :key="i1"
                    v-if="i1 < 3"
                    >{{ lang == "zh" ? chil.userName : chil.userEName }}</Tag
                  >
                </div>
                <Poptip
                  placement="right"
                  width="400"
                  v-if="
                    item.t2SuccessorInfoList &&
                      item.t2SuccessorInfoList.length > 3
                  "
                >
                  <Button icon="ios-more" size="small"></Button>
                  <div class="Poptipapi" slot="content">
                    <Tag
                      v-for="(chil, i1) in item.t2SuccessorInfoList"
                      :key="i1"
                      >{{ lang == "zh" ? chil.userName : chil.userEName }}</Tag
                    >
                  </div>
                </Poptip>
                <div>
                  <Button
                    type="primary"
                    :disabled="
                      item.disabledFlag == 1 ||
                        beEnd == 1 ||
                        beEnd == 4 ||
                        item.stageEmpEnd == '1' ||
                        $route.query.tab2 == '1'
                    "
                    style="margin-left:5px"
                    @click="selectUser(item, 2, 't2SuccessorInfoList')"
                    icon="md-person-add"
                    size="small"
                  ></Button>
                  <Button
                    type="warning"
                    :disabled="
                      item.disabledFlag == 1 ||
                        beEnd == 1 ||
                        beEnd == 4 ||
                        item.stageEmpEnd == '1' ||
                        $route.query.tab2 == '1'
                    "
                    style="margin-left:5px"
                    @click="deleteUser(item, item.t2SuccessorInfoList, 2)"
                    icon="ios-trash-outline"
                    size="small"
                  ></Button>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <div
        style="display: flex;width: 100%;justify-content: space-between;align-items: flex-start;margin-top:30px"
        v-if="id != ''"
      >
        <Form :model="formItem" :label-width="170" inline>
          <FormItem :label="$t('Succession_rate(China)')"
            ><!-- 中国区继任率 -->
            <Input type="text" v-model="chinaSuccession.data" readonly />
          </FormItem>
          <FormItem :label="$t('Succession_rate(Group)')"
            ><!-- Group继任率 -->
            <Input type="text" v-model="groupSuccession.data" readonly />
          </FormItem>
          <FormItem :label="$t('PB_T1_Succession_rate_Distinct')"
            ><!-- T1继任率（去重） -->
            <Input
              type="text"
              v-model="disGroupSuccessionRateAlgorithm.data"
              readonly
            />
          </FormItem>
        </Form>
        <div class="btn">
          <Button @click="personPage"
            ><!-- 人才比对 -->{{ $t("Talent_Comparison") }}</Button
          >
          <!-- <Button @click="modal=true" v-if="id!=''">追加空岗</Button> -->
        </div>
      </div>
    </div>
    <Modal v-model="modal" title="追加空岗" @on-ok="save">
      <Form :model="modalFormItem" :label-width="160">
        <FormItem label="空岗职位">
          <Input
            style="width:200px"
            type="text"
            v-model="modalFormItem.jobName"
          />
        </FormItem>
        <FormItem label="业务单元">
          <Select
            disabled
            v-model="modalFormItem.businessUnit"
            style="width:200px"
            placeholder=""
          >
            <Option
              v-for="item in businessUnitList"
              :value="item.code"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="部门">
          <Select
            disabled
            v-model="modalFormItem.department"
            style="width:200px"
            placeholder=""
          >
            <Option
              v-for="item in departmentList"
              :value="item.code"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="职位">
          <Select
            disabled
            v-model="modalFormItem.position"
            style="width:200px"
            placeholder=""
          >
            <Option
              v-for="item in positionList"
              :value="item.code"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="Band">
          <Select v-model="modalFormItem.hcmBand" style="width:200px">
            <Option
              v-for="item in Band"
              :value="item.ch_value"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="职务描述（中文）">
          <Input
            style="width:200px"
            type="text"
            v-model="modalFormItem.positionCTitle"
          />
        </FormItem>
        <FormItem label="职务描述（英文）">
          <Input
            style="width:200px"
            type="text"
            v-model="modalFormItem.positionETitle"
          />
        </FormItem>
      </Form>
    </Modal>
    <selectPeopleVue
      ref="selectPeopleVue"
      @onSelectList="onSelectList"
    ></selectPeopleVue>
    <Modal
      width="92%"
      v-model="deleteModal"
      :title="$t('Employee_Selected')"
      @on-ok="handleDeleteUser()"
    >
      <Table
        highlight-row
        border
        :columns="modelColumns"
        :data="selectAllPeoData"
        @on-selection-change="itemClick"
        ref="deletePeoTable"
      >
      </Table>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import selectPeopleVue from "../../performanceManagement/components/selectPeople";
import axios from "axios";
export default {
  components: { selectPeopleVue },
  data() {
    return {
      chinaSuccession: {},
      groupSuccession: {},
      disGroupSuccessionRateAlgorithm: {},
      modal: false,
      dataList: [],
      id: "",
      immediateSupervisor: {
        userName: "",
        t1SuccessorInfoList: [],
        t2SuccessorInfoList: []
      },
      employee: {},
      tIndex: "",
      formItem: {},
      modalFormItem: {},
      positionList: [],
      departmentList: [],
      businessUnitList: [],
      Band: [],
      spinShow: false,
      serialnumber: "",
      beTopLevel: "",
      deleteModal: false,

      selectPeoData: [],
      selectAllPeoData: [],
      beEnd: ""
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    modelColumns() {
      return [
        {
          type: "selection",
          minWidth: 60,
          align: "center"
        },
        {
          title: this.$t("Employee_Code"),
          key: "successorEmpCode",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Name"),
          key: "userName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("English_Name"),
          key: "userEName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position_Name_Chinese"),
          key: "position",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position_Name_English"),
          key: "positionETitle",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Band") /* Band */,
          key: "hcmBand",
          align: "center",
          minWidth: 200
        }
      ];
    }
  },
  created() {
    this.getListData();
  },
  methods: {
    itemClick(selection) {
      this.selectPeoData = selection;
    },
    deleteUser(item, peoList, index) {
      this.employee = JSON.parse(JSON.stringify(item));
      this.tIndex = index;
      this.selectAllPeoData = peoList;
      this.$nextTick(() => {
        this.$refs.deletePeoTable.selectAll(true);
      });
      this.deleteModal = true;
    },
    handleDeleteUser() {
      this.deleteModal = false;
      this.onSelectList(this.selectPeoData);
    },
    getData() {
      this.spinShow = true;
      axios
        .post("/talentInventoryUser/successionInventory", {
          talentInventoryId: this.id,
          serialnumber: this.serialnumber
            ? this.serialnumber
            : this.$route.query.serialnumber,
          beTopLevel: this.beTopLevel
        })
        .then(res => {
          this.spinShow = false;
          if (res) {
            this.dataList = res.employee;
            this.immediateSupervisor = res.immediateSupervisor[0];
            this.chinaSuccession = res.chinaSuccession;
            this.chinaSuccession.data = this.chinaSuccession.data + "%";
            this.groupSuccession = res.groupSuccession;
            this.groupSuccession.data = this.groupSuccession.data + "%";
            this.disGroupSuccessionRateAlgorithm =
              res.disGroupSuccessionRateAlgorithm;
            this.disGroupSuccessionRateAlgorithm.data =
              this.disGroupSuccessionRateAlgorithm.data + "%";
            this.modalFormItem.businessUnit =
              res.immediateSupervisor[0].businessUnitCode;
            this.modalFormItem.department =
              res.immediateSupervisor[0].departmentCode;
            this.modalFormItem.position =
              res.immediateSupervisor[0].positionCode;
            this.beEnd = res.beEnd;
          }
        });
    },
    selectUser(item, index, key) {
      this.tIndex = index;
      this.employee = JSON.parse(JSON.stringify(item));
      let obj = JSON.parse(JSON.stringify(item));
      this.$refs.selectPeopleVue.modal = true;
      this.$refs.selectPeopleVue.successorPeople = 1;
      this.$refs.selectPeopleVue.positionCode = item.positionCode;
      this.$refs.selectPeopleVue.successorLevel = index;
      this.$refs.selectPeopleVue.talentInventoryId = this.id;
      this.$refs.selectPeopleVue.immediateSerialnumber = this.immediateSupervisor.serialnumber;
      this.$refs.selectPeopleVue.modelColumns.unshift({
        type: "selection",
        minWidth: 60,
        align: "center"
      });
      obj[`${key}`].forEach(element => {
        element.empCode = element.successorEmpCode;
        element.serialnumber = element.successorSerialnumber;
      });
      this.$refs.selectPeopleVue.selectList = obj[`${key}`];
      this.$refs.selectPeopleVue.modelData = [];
      // this.$refs.selectPeopleVue.getData()
    },
    onSelectList(list) {
      let obj = {
        meetingId: this.id,
        ...this.employee,
        successorSerialnumberList: list,
        successorLevel: this.tIndex,
        beNullJob: this.employee.beNullJob,
        dirSupPosition: this.immediateSupervisor.position
      };
      axios.post("/successorInfo/insertSuccessionInfo", obj).then(res => {
        if (res) {
          this.$Message.success(res);
          this.getData();
        }
      });
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.positionList = res.positionList;
          this.departmentList = res.departmentList;
          this.businessUnitList = res.businessUnitList;
          this.Band = res.Band;
        }
      });
    },
    save() {
      let obj = {
        meetingId: this.id,
        ...this.modalFormItem,
        successorSerialnumberList: [],
        successorLevel: this.tIndex,
        beNullJob: 1,
        dirSupPosition: this.immediateSupervisor.position
      };
      axios.post("/successorInfo/insertSuccessionInfo", obj).then(res => {
        if (res) {
          this.$Message.success(res);
          this.getData();
        }
      });
    },
    deleteItem(row) {
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        onOk: () => {
          axios
            .post("/successorInfo/deleteSuccessionInfo", { id: row.id })
            .then(res => {
              if (res) {
                this.$Message.success(res);
                this.getData();
              }
            });
        }
      });
    },
    personPage() {
      const href = this.$router.resolve({
        path: "/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27",
        query: { id: 1 }
      });
      window.open(
        "/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27?id=1",
        "_blank"
      );
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  position: relative;
}
.modalBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin-top: 20px;
  .tit {
    color: #000000;
    font-weight: bold;
    margin-right: 8px;
  }
  .row {
    display: flex;
    align-items: center;
    margin: 2px 0;
  }
  .btn {
    display: flex;
    justify-content: flex-end;
    // width: 100%;
    button {
      margin-right: 20px;
    }
  }
  .modalTop {
    padding: 10px 50px;
    border-radius: 10px;
    box-shadow: 8px 8px 8px #adadad;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 28px;
    box-sizing: border-box;
    border-width: 3px;
    border-style: solid;
    .topHeader {
      margin-top: -30px;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  .modalContent {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 10px;

    .modalItem {
      // border-radius: 10px;
      // border:2px solid #adadad;
      // padding: 10px;
      margin: 10px;
      p {
        font-weight: bold;
        width: 88% !important;
      }

      .cardItem {
        width: 255px;
      }
    }
  }
}
.userList {
  // background: rgb(235, 235, 235);
  padding: 3px 0px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  .Poptipapi {
    display: flex;
    flex-wrap: wrap;
  }
}
/deep/.ivu-card-head {
  padding: 8px 8px !important;
}
/deep/.ivu-card-body {
  padding: 8px 8px !important;
}
/deep/.ivu-tag {
  padding: 0 5px;
}
/deep/.ivu-card-extra {
  top: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/teamInfoComponents/tabPane3.vue